import { VCard } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VDivider } from 'vuetify/lib/components/VDivider';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c(VCard,{staticClass:"bg-gray",attrs:{"id":"card","flat":""}},[_c(VCardTitle,{staticClass:"ma-0 pa-0 px-5",attrs:{"id":"headerFrame"}},[_c('h4',[_vm._v(_vm._s(_vm.personalEval.questionText))])]),_c(VDivider,{attrs:{"id":"divider"}}),_c('div',{attrs:{"id":"circleFrame"}},[_c('DoughnutChart',{attrs:{"data":_vm.personalEval.scores}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }